import { MediaContextProvider, mediaStyle } from '~shared/components/media'

export const RootProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <style type='text/css'>{mediaStyle}</style>
      <MediaContextProvider>{children}</MediaContextProvider>
    </>
  )
}
